import { Column } from "../../../../core/components/Column";
import { Row } from "../../../../core/components/Row";
import { StartSection } from "../../../../core/components/StartSection";
import { TextComponent } from "../../../../core/components/TextComponent";
import guiaProveedoresData from "../../../../core/data/db_guia_proveedores.json";
import { CategoriesList, Invitacion } from "../components/CategoriesList";

interface CategoriasDetalle {
	titulo_subcategoria: string;
	descripcion_subcategoria: string;
	imagen_subcategoria: string;
	categorias_subdetalle: Invitacion[];
}

export const Clothing: React.FC = () => {
	const section = guiaProveedoresData.Vestimenta;
	const categories = Array.isArray(section.categorias) ? section.categorias : [];

	return (
		<>
			<StartSection
				titulo={section.titulo}
				backgroundImage={section.imagen}
				description={section.descripcion}
			/>
			{categories.map((category) => {
				const isCategoriasDetalle = (category.categorias_detalle as any[]).every((item) => item.titulo_subcategoria && item.categorias_subdetalle);
				if (isCategoriasDetalle) {
					return (
						<>
							<Row
								className="w-full gap-2 md:gap-4 p-5 mt-5 bg-white shadow"
								mainAxisAlignment="center"
								crossAxisAlignment="center"
							>
								<TextComponent
									variant="h1"
									className="font-baskerville font-bold text-center text-primarySunset "
								>
									{category.titulo_principal}
								</TextComponent>
							</Row>
							{(category.categorias_detalle as CategoriasDetalle[]).map((ca) => (
								<Column className="border border-primarySunset rounded-xl m-4 md:mx-8 w-fit self-center">
									<div className="w-full sm:w-[40rem] md:w-[90%] xl:w-[60rem]">
										<TextComponent
											variant="h2"
											className="uppercase font-baskerville font-bold text-center text-primarySunset p-4 md:p-8 !pb-0"
										>
											{ca.titulo_subcategoria}
										</TextComponent>
										<CategoriesList categories={ca.categorias_subdetalle} />
									</div>
								</Column>
							))}
						</>
					);
				} else {
					return (
						<>
							<Row
								className="w-full gap-2 md:gap-4 p-5 mt-5 bg-white shadow"
								mainAxisAlignment="center"
								crossAxisAlignment="center"
							>
								<TextComponent
									variant="h1"
									className="font-baskerville font-bold text-center text-primarySunset "
								>
									{category.titulo_principal}
								</TextComponent>
							</Row>
							<main className="self-center w-full sm:w-[40rem] md:w-[90%] xl:w-[60rem] mb-4 sm:mb-8">
								<CategoriesList categories={category.categorias_detalle as Invitacion[]} />
							</main>
						</>
					);
				}
			})}
		</>
	);
};
